import qs from 'querystring'
import { InitOptions, LanguageDetectorModule, Services } from 'i18next'

const supportedLanguages = ['en', 'de']

const isLanguageValid = (language: string) =>
  supportedLanguages.includes(language.toLowerCase())

class LanguageDetector implements LanguageDetectorModule {
  services: Services
  allOptions: InitOptions
  type = 'languageDetector' as LanguageDetectorModule['type']
  static type = 'languageDetector' as LanguageDetectorModule['type']

  constructor(services: Services, _: any, allOptions: InitOptions) {
    this.services = services
    this.allOptions = allOptions
  }

  init(services: Services, _: any, allOptions: InitOptions) {
    this.services = services
    this.allOptions = allOptions
  }

  detect() {
    return this.getCurrentLanguage()
  }

  cacheUserLanguage(language: string) {
    try {
      window.localStorage.setItem('language', language)
    } catch (e) {}
  }

  getLanguageFromNavigator = (): string | undefined => {
    try {
      return window.navigator.language.substring(0, 2) || undefined
    } catch (e) {}

    return
  }

  getLanguageFromLocalStorage = (): string | undefined => {
    try {
      return localStorage.getItem('language') || undefined
    } catch (e) {}

    return
  }

  getLanguageFromUrl = (): string | undefined => {
    const { lang: langFromSearch } = qs.parse(
      window.location.search.substring(1)
    )

    const { lang: langFromHash } = qs.parse(
      window.location.hash.split('?')?.[1] || ''
    )

    const lang = langFromHash || langFromSearch

    if (typeof lang !== 'string') return

    return lang
  }

  getFallbackLanguage(fallback: string): string {
    const fallbackLng = this.allOptions.fallbackLng

    if (typeof fallbackLng === 'string') return fallbackLng

    if (Array.isArray(fallbackLng) && fallbackLng.length > 0)
      return fallbackLng[0]

    return fallback
  }

  getCurrentLanguage = () => {
    const language =
      this.getLanguageFromUrl() ||
      this.getLanguageFromLocalStorage() ||
      this.getLanguageFromNavigator()

    if (language && isLanguageValid(language)) return language

    return this.getFallbackLanguage('de')
  }
}

export default LanguageDetector
